import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '../../../../theme';
const TEAL_COLOR = '#4FC4C4';
const TEAL_BG = 'rgba(79, 196, 196, 0.12)';
const TEAL_BORDER = 'rgba(79, 196, 196, 0.25)';
const SUBTLE_BG = 'rgba(255, 255, 255, 0.04)';
const SUBTLE_BORDER = 'rgba(255, 255, 255, 0.08)';
// Ring classes apply when a consumer opts into focusability via tabIndex.
const BASE_CLASSES = 'inline-flex items-center rounded-full font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1';
export const VibeTag = forwardRef(({ subtle = false, children, className, style, ...rest }, ref) => {
    const theme = useTheme();
    const vibeStyles = {
        fontFamily: theme.typography.fontFamily,
        fontSize: '11px',
        fontWeight: 500,
        textTransform: 'lowercase',
        padding: '2px 8px',
        borderWidth: '0.5px',
        borderStyle: 'solid',
        backgroundColor: subtle ? SUBTLE_BG : TEAL_BG,
        color: subtle ? theme.colors.textMuted : TEAL_COLOR,
        borderColor: subtle ? SUBTLE_BORDER : TEAL_BORDER,
        '--tw-ring-color': theme.colors.ring,
        ...style,
    };
    const classes = [BASE_CLASSES, className].filter(Boolean).join(' ');
    return (_jsx("span", { ref: ref, className: classes, style: vibeStyles, ...rest, children: children }));
});
VibeTag.displayName = 'VibeTag';
